var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    class: {
      'disabledSelect': _vm.disableDropDown || _vm.completed || _vm.showOptions
    }
  }, [_vm.label ? _c('label', {
    domProps: {
      "textContent": _vm._s(_vm.label)
    }
  }) : _vm._e(), _c('div', {
    class: [{
      'alert': _vm.alert
    }, 'select'],
    attrs: {
      "id": "select"
    },
    on: {
      "click": _vm.openDropDown
    }
  }, [_c('div', [_vm.blinkingText ? _c('blinking-cursor-text', {
    attrs: {
      "text": _vm.blinkingText,
      "text-step": _vm.stepIndex
    }
  }) : _vm._e()], 1), _vm._m(0)]), _vm.answers ? _c('div', {
    staticClass: "options-container"
  }, _vm._l(_vm.displayOptions, function (option, index) {
    return _c('div', {
      key: index,
      staticClass: "option",
      attrs: {
        "track-by": "$index"
      },
      on: {
        "click": function ($event) {
          return _vm.selectOption(option);
        }
      }
    }, [_c('p', {
      domProps: {
        "textContent": _vm._s(option.text)
      }
    })]);
  }), 0) : _vm._e()]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "arrow"
  }, [_c('div')]);
}]

export { render, staticRenderFns }